<template>
  <div>
    <NativeCreativePreview
      :advertiser="advertiser"
      :creative="creative"
      :form="form"
      :index="index"
      :size="size"
      v-if="(
        form &&
        (
          form.format === 'NATIVE_DISPLAY' ||
          form.format === 'PUSH'
        )
      ) ||
      (
        creative && (
          creative.format === 'NATIVE_DISPLAY' ||
          creative.format === 'PUSH'
        )
      )"
    />
  </div>
</template>

<script>

import NativeCreativePreview from '@/components/creatives/CreativePreview/NativeCreativePreview'

export default {
  props: ['advertiser', 'creative', 'form', 'index', 'size'],
  name: 'CreativePreviewWrapper',
  components: {
    NativeCreativePreview
  }
}
</script>
